import React from "react";
import { Text, View } from "react-native";
import { borderAlphas, surfaces } from "../../lib/theme/tokens";
import * as zero from "../../ui";
import { Chat } from "../chat/chat";
import { ChatBox } from "../chat/chat-box";

const { flex, bg, r, borders, p, px, py, text, layout } = zero;

interface ChatPanelProps {
  isLive: boolean;
  isConnected: boolean;
  messagesPerMinute?: number;
  shownMessages?: number;
  emojiData?: any;
  emojiPicker?: (
    isOpen: boolean,
    onClose: () => void,
    onSelect: (emoji: any) => void,
  ) => React.ReactNode;
}

export default function ChatPanel({
  isLive,
  isConnected,
  messagesPerMinute = 0,
  shownMessages = 50,
  emojiData = null,
  emojiPicker,
}: ChatPanelProps) {
  return (
    <View
      style={[
        flex.values[1],
        { backgroundColor: surfaces.dark[1] },
        borders.width.thin,
        { borderColor: borderAlphas.dark.strong },
        layout.flex.column,
        r.lg,
      ]}
    >
      <View
        style={[
          layout.flex.row,
          layout.flex.spaceBetween,
          layout.flex.alignCenter,
          borders.bottom.width.thin,
          { borderBottomColor: borderAlphas.dark.strong },
          p[4],
        ]}
      >
        <Text style={[text.white, { fontSize: 15, fontWeight: "600" }]}>
          Chat
        </Text>
        <View style={[layout.flex.row, layout.flex.alignCenter]}>
          <View
            style={[
              { width: 6, height: 6, borderRadius: 3 },
              isLive && isConnected ? bg.green[500] : bg.gray[500],
            ]}
          />
          <Text style={[text.gray[400], { fontSize: 12, marginLeft: 8 }]}>
            {messagesPerMinute} msg/min
          </Text>
        </View>
      </View>
      <View style={[flex.values[1], px[2], { minHeight: 0 }]}>
        <View style={[flex.values[1], { minHeight: 0 }]}>
          <Chat shownMessages={shownMessages} />
        </View>
        <View style={[{ flexShrink: 0 }]}>
          <ChatBox
            emojiData={emojiData}
            emojiPicker={emojiPicker}
            chatBoxStyle={[
              { backgroundColor: surfaces.dark[2] },
              borders.width.thin,
              { borderColor: borderAlphas.dark.strong },
              r.md,
              p[3],
              !isConnected && { opacity: 0.6 },
            ]}
          />
        </View>
      </View>
    </View>
  );
}
